import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { cleanupProps } from '@infl-ts/util-cleanup-props';
import { mergeSxProps } from '@infl-ts/util-merge-sx-props';
import { Paper } from '@mui/material';
import { forwardRef } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export var ListItemContainer = /*#__PURE__*/forwardRef(function ListItemContainer(props, ref) {
  return /*#__PURE__*/_jsx("li", _objectSpread(_objectSpread({
    ref: ref
  }, cleanupProps(props)), {}, {
    children: /*#__PURE__*/_jsx(Paper, _objectSpread(_objectSpread({}, props), {}, {
      sx: mergeSxProps({
        minHeight: 100
      }, props.sx)
    }))
  }));
});